export default __webpack_public_path__ + "static/media/ilustração_8.738432cf.png";